import Button from "../componenet/Button";

const ServicesSection = () => {
  const services = [
    {
      icon: "📱",
      title: "Social Media Management",
      desc: "We run your page like it’s ours — content, captions, posting, and strategy. No fluff — just a system that builds real followers, engagement, and trust.",
      points: ["Reels & post design", "Captions & strategy", "Consistent uploads", "Full content planning"],
    },
    {
      icon: "👤",
      title: "Personal Brand Growth",
      desc: "You bring the personality — we package it. We help creators, founders, and entrepreneurs grow their voice online through smart content and consistent positioning.",
    },
    {
      icon: "🎬",
      title: "Video Editing",
      desc: "Fast-paced, platform-ready edits that stop the scroll. From Reels to YouTube to ad creatives — we deliver videos that look good and keep attention.",
    },
    {
      icon: "🎨",
      title: "Graphic Designing",
      desc: "Designs that match your message. From IG carousels to brand kits, everything is clean, sharp, and built to perform.",
    },
    {
      icon: "💻",
      title: "Web Design",
      desc: "Sleek, responsive websites that speak for your brand. We design fast-loading sites that look modern, work on mobile, and make it easy for people to take action.",
    },
    {
      icon: "✉️",
      title: "Email Marketing",
      desc: "Emails people actually read. We write and design campaigns that tell your story, build trust, and bring results — no spammy tricks.",
    },
    {
      icon: "🔍",
      title: "SEO",
      desc: "We help your site get found, rank better, and bring in long-term organic traffic through smart on-page SEO and clean structure.",
    },
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 py-10 relative w-full overflow-hidden" id="services">
      {/* Decorative Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background to-background/80 -z-10"></div>

      {/* Heading */}
      <div className="text-center mb-16">
        <Button variant="addsection" className="mb-6">SERVICES</Button>
        <h2 className="text-4xl md:text-5xl font-extrabold text-primary mb-4">What We Offer</h2>
        <p className="text-gray-300 max-w-2xl mx-auto text-lg">
          From strategy to execution — we cover all the essentials you need to <span className="text-primary font-semibold">grow your brand</span>.
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
        {services.map((service, idx) => (
          <div
            key={idx}
            data-aos="fade-up"
            data-aos-delay={idx * 120}
            className="group relative bg-background/60 backdrop-blur-lg border border-secondary/40 rounded-2xl p-8 flex flex-col justify-between hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 h-full"
          >
            {/* Icon Badge */}
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary/10 text-3xl mb-6">
              {service.icon}
            </div>

            {/* Title */}
            <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-primary transition">
              {service.title}
            </h3>

            {/* Description */}
            <p className="text-gray-300 mb-4 flex-grow">{service.desc}</p>

            {/* Points */}
            {service.points && (
              <ul className="list-disc list-inside text-gray-400 space-y-2 text-sm">
                {service.points.map((point, pIdx) => (
                  <li key={pIdx}>{point}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
